
import SettingsService from 'live/services/settings'
import ReportsMakerSettingsPage from './ReportsMakerSettingsPage'


SettingsService.register(ReportsMakerSettingsPage)

